











































































import Vue from 'vue';
import Component from 'vue-class-component';
import AddressForm from '@/components/AddressForm.vue';
import { TextInput } from '@/components/FormInputs/FormInputs';

@Component({
	components: {
		AddressForm,
		TextInput,
	}
})
export default class AgentToClaimantView extends Vue {
	private isLoading: boolean = true;

	public async created() {
		if (this.$store.getters['InterviewModule/filingType'] === 'C') {
			this.$router.push('/Interview/Deceased');
			return;
		}

		this.$store.commit('InterviewModule/updatePageName', 'AgentToClaimant');
		if (this.$route.params.refreshFormData) {
			await this.$store.dispatch('InterviewModule/getFormData', 'AgentToClaimant');
		}

		this.isLoading = false;
	}

	public AddressToolTip: any = {
		"AgentToClaimant.Address.AddressLine1": "Provide the street address of the agent to the claimant",
		"AgentToClaimant.Address.City": "Provide the City of the agent to the claimant",
		"AgentToClaimant.Address.StateCode": "Provide the State  of the agent to the claimant",
		"AgentToClaimant.Address.CountyCode": "Provide the County of the agent to the claimant if located in New York",
		"AgentToClaimant.Address.Zip": "Provide the zip code of the agent to the claimant",
		"AgentToClaimant.Address.CountryCode": "Provide the Country of the agent to the claimant"
	}

	public get AddressToolTip2Str(): string {
		return JSON.stringify(this.AddressToolTip);
	}
}
